import React from "react";
import { useTranslation } from "react-i18next";
import ApplyFilterButton from "../../component/ApplyFilter";

const getEventLabel = (event) =>
  event === "simPurchase" ? "Sim Purchased" : "Topup";

const TransactionsListingFilters = ({
  filters,
  vendorOptions,
  dataOptions,
  validityOptions,
  eventOptions,
  onFilterChange,
  onApplyFilter,
  onClearFilters,
}) => {
  const { t } = useTranslation();

  return (
    <div className="transactions-listing-filter-panel">
      <select
        value={filters.vendor}
        onChange={(event) => onFilterChange("vendor", event.target.value)}
        className="transactions-listing-filter-control"
      >
        <option value="">All Vendors</option>
        {vendorOptions.map((vendor) => (
          <option key={vendor} value={vendor}>
            {vendor}
          </option>
        ))}
      </select>
      <select
        value={filters.days}
        onChange={(event) => onFilterChange("days", event.target.value)}
        className="transactions-listing-filter-control"
      >
        <option value="">All Days</option>
        {validityOptions.map((validity) => (
          <option key={validity} value={validity}>
            {validity} {t("home.part21")}
          </option>
        ))}
      </select>
      <select
        value={filters.data}
        onChange={(event) => onFilterChange("data", event.target.value)}
        className="transactions-listing-filter-control"
      >
        <option value="">All Data</option>
        {dataOptions.map((data) => (
          <option key={data} value={data}>
            {Number(data) > 0
              ? `${Number(data)} ${t("home.part22")}`
              : t("home.part33")}
          </option>
        ))}
      </select>
      <select
        value={filters.event}
        onChange={(event) => onFilterChange("event", event.target.value)}
        className="transactions-listing-filter-control"
      >
        <option value="">All Events</option>
        {eventOptions.map((event) => (
          <option key={event} value={event}>
            {getEventLabel(event)}
          </option>
        ))}
      </select>
      <ApplyFilterButton onApply={onApplyFilter} />
      <button
        type="button"
        onClick={onClearFilters}
        className="transactions-listing-clear-filter"
      >
        Clear
      </button>
    </div>
  );
};

export default TransactionsListingFilters;
